import { Component, OnInit, SkipSelf } from '@angular/core';
import { EdlCfGenericComponent } from '@edl-development/edl-custom-forms';
import { PaetepCfAnswerContextInfoModel } from '../../../answer-models/paetep-cf-answer-context-info.model';
import { PaetepCfContextInfoModel } from '../../../item-models/paetep-cf-context-info.model';
import { ContextInfoCustomFormType } from 'src/app/model/enum/observations/custom-forms/custom-form-context-info-type.enum';
import { CustomFormsSharedDataService } from '../../services/custom-forms-shared-data/custom-forms-shared-data.service';
import { ControlContainer } from '@angular/forms';
import { CustomFormUserFormDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-user-form-display-dto.model';
import { Building, DateHelpers } from '@edl-development/edl-common';
import { DatePipe } from '@angular/common';
import { SorterHelper } from 'src/app/model/helpers/sorters/sorter.helper';

export const DATE_FORMAT = 'M/d/yyyy h:mm a';
export const DATE_NOT_SET = 'Not Set';
export const NOT_COMPLETED = 'Not Completed';

@Component({
    selector: 'paetep-cf-display-context-info',
    templateUrl: './paetep-cf-display-context-info.component.html',
    styleUrls: ['./paetep-cf-display-context-info.component.scss'],
    viewProviders: [{
        provide: ControlContainer,
        useFactory: (container: ControlContainer) => container,
        deps: [[new SkipSelf(), ControlContainer]]
    }]
})
export class PaetepCfDisplayContextInfoComponent extends EdlCfGenericComponent<PaetepCfContextInfoModel, PaetepCfAnswerContextInfoModel> implements OnInit {

    constructor(private customFormsSharedDataService: CustomFormsSharedDataService, private container: ControlContainer,) {
        super();
    }

    public displayText?: string | null;
    public shouldShowBuildings: boolean = false;
    public buildings: Building[] = [];
    public nonExistingBuilding?: string;
    

    ngOnInit(): void {
        this.displayText = this.getDisplayText(this.customFormsSharedDataService.userForm);
        this.shouldShowBuildings = this.model.config.contextType === ContextInfoCustomFormType.BUILDING;
        this.buildings = this.customFormsSharedDataService?.targetUserBuildings?.sort((b1, b2) => SorterHelper.alphaSort(b1.name, b2.name)) ?? [];
        
        const answer = this.container.control?.get('answer');
        if (this.shouldShowBuildings && answer && !answer.value && this.buildings.length > 0) {
            answer.setValue(this.buildings[0].name);
        }

        this.nonExistingBuilding = (answer?.value && !this.buildings.some(b => b.name === answer.value)) ? answer.value : undefined;
    }

    private getDisplayText(userForm?: CustomFormUserFormDisplayDTO) {
        switch(this.model.config.contextType) {
            case ContextInfoCustomFormType.COMPLETED_DATE:
                return this.transformDate(userForm?.completedDate, NOT_COMPLETED);
            case ContextInfoCustomFormType.EVALUATOR:
                return userForm?.supervisorName;
            case ContextInfoCustomFormType.START_DATE:
                return this.transformDate(userForm?.createdDate, DATE_NOT_SET);
            case ContextInfoCustomFormType.TARGET:
                return userForm?.targetUserName;
            default:
                return null;
        }
    }

    private transformDate(date?: Date, defaultText?: string) {
        const validatedDate = date ? DateHelpers.validDate(date) : null;
        return validatedDate ? new DatePipe('en-US').transform(validatedDate, DATE_FORMAT) : defaultText;
    }
}
